import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import ResolverIframe from '@swf/components/Iframe/ResolverIframe';
import Translation from '@swf/components/Translation/Translation';
import { PostMessage } from '@swf/core/enums';
import { StatusCode } from '@swf/core/enums/statusCode';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import sharedStyles from './../RegistrationForm/RegistrationForm.scss';
import {
  TXTCLI_Please_waitX_This_might_take_a_ELL,
  TXTCLI_You_are_required_to_authentica_ELL,
  TXTMOB_Something_went_wrongX_Please_t_ELL
} from './NemIdForm.messages.json';
import styles from './NemIdForm.scss';

const NemIdForm: React.FC = () => {
  const [showIframe, setShowIframe] = useState(true);
  const [loginCompleted, setLoginCompleted] = useState(false);
  const [statusCode, setStatusCode] = useState<StatusCode>();

  const brandName = useSelector(select.cms.getBrandName);

  const {
    state: { message, userId, password }
  } = useLocation<{ message: string; userId: string; password: string }>();

  const {
    auth: { login }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    const handleMessage = async ({ data }: { data: PostMessage }) => {
      if (data === PostMessage.NEMID_LOGGEDIN) {
        setShowIframe(false);
        const responseStatusCode = await login({ userId, password, nemIdLoggedIn: true });
        setStatusCode(responseStatusCode);
        setLoginCompleted(true);
      }
    };
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [login, userId, password]);

  switch (true) {
    case showIframe:
      return (
        <>
          <Translation tagName="p" {...TXTCLI_You_are_required_to_authentica_ELL} />
          <ResolverIframe
            tag="dk-nemid-verification"
            className={styles.form}
            query={{ nemid: message, mobile: true, source: 'ram', brand: brandName }}
            scrolling="auto"
          />
        </>
      );
    case loginCompleted && statusCode !== StatusCode.OK:
      return (
        <p className={sharedStyles.error}>
          <Translation {...TXTMOB_Something_went_wrongX_Please_t_ELL} />
        </p>
      );
    default:
      return <Translation tagName="p" {...TXTCLI_Please_waitX_This_might_take_a_ELL} />;
  }
};

export default NemIdForm;
